import { render } from "./GameTwo.vue?vue&type=template&id=97dd1340"
import script from "./GameTwo.vue?vue&type=script&lang=js"
export * from "./GameTwo.vue?vue&type=script&lang=js"

import "./GameTwo.vue?vue&type=style&index=0&id=97dd1340&lang=css"

import exportComponent from "C:\\src\\Inmersys\\tres-prima\\mundo-zac-webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__